module.exports = __webpack_public_path__ + "aware_logo-9b1f3c9999c208bbee1b30029a3f08c6.png";